import {
  getDOMComponentBaseName,
  getDOMComponentDomain,
  getDOMComponentDomainPath,
  getDOMComponentLabels,
} from "helpers";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BasketKPLabels } from "./components/BasketKP.types";
import BasketPage from "./components/BasketPage";

type TBasketEGProps = {
  rootElement: HTMLElement;
};

function BasketKP({ rootElement }: TBasketEGProps) {
  const domain = getDOMComponentDomain(rootElement) ?? "";
  const basename = getDOMComponentBaseName(rootElement);
  const domainPath = getDOMComponentDomainPath(rootElement);
  const labelsJSON = getDOMComponentLabels(rootElement);
  const pageId = rootElement?.getAttribute("data-page-id") || "";

  if (!labelsJSON || !domain || !domainPath) {
    return <></>;
  }

  const labels = JSON.parse(labelsJSON) as BasketKPLabels;

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route
          path="/"
          element={
            <div className="o-basket">
              <h2>{labels.BasketTotalText}</h2>
              <BasketPage
                labels={labels}
                domain={domain}
                domainPath={domainPath}
                pageId={pageId} />
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default BasketKP;
